<section id="section-active-designs" hlmCard>
  <div hlmCardHeader>
    <h2 hlmCardTitle>So sehen deine Gutscheine aus</h2>
    <p hlmCardDescription>
      Jeder Gutschein, den du verkaufst oder erstellst, wird als PDF mit diesem Design gedruckt:
      eines für Wert-Gutscheine, eines für Produkt-Gutscheine.
    </p>
  </div>

  <div hlmCardContent>
    @if (loading()) {
      <div class="space-y-3" aria-busy="true">
        <hlm-skeleton class="h-36 w-full" />
        <hlm-skeleton class="h-36 w-full" />
      </div>
    } @else {
      <ul class="space-y-3">
        @for (slot of slots(); track slot.type) {
          <!-- Phones: preview beside the name, notes and buttons below at full width.
               From sm up the preview spans both rows, so notes and buttons sit beside it. -->
          <li
            class="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2 rounded-lg border p-3 sm:grid-rows-[auto_1fr] sm:gap-x-4">
            @if (slot.design; as design) {
              <!-- A shortcut to the editor for mouse and touch; "Bearbeiten" is the keyboard way. -->
              <a
                class="focus-visible:ring-ring w-24 rounded focus-visible:ring-2 focus-visible:outline-none sm:row-span-2 sm:w-32"
                [class.opacity-50]="!slot.enabled"
                tabindex="-1"
                aria-hidden="true"
                [routerLink]="['/voucher-designs', design.public_id]">
                <app-design-thumbnail [design]="design" />
              </a>
            } @else {
              <div
                class="bg-muted/40 text-muted-foreground flex w-24 items-center justify-center rounded border border-dashed sm:row-span-2 sm:w-32"
                [class.opacity-50]="!slot.enabled"
                style="aspect-ratio: 210 / 297"
                aria-hidden="true">
                <ng-icon name="lucideLayoutTemplate" size="24" />
              </div>
            }

            <div class="min-w-0">
              <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
                <h3 hlmMuted class="text-xs font-medium tracking-wide uppercase">
                  {{ slot.label }}e
                </h3>
                @if (!slot.enabled) {
                  <span hlmBadge variant="outline">Ausgeschaltet</span>
                }
              </div>
              @if (slot.design; as design) {
                <p class="truncate font-semibold">{{ design.name }}</p>
                <p hlmMuted class="text-xs">{{ sizeLabel(design) }}</p>
              } @else {
                <p class="font-semibold">Standardvorlage</p>
                <p hlmMuted class="text-xs">
                  Noch kein eigenes Design gewählt. Lege unten eines an.
                </p>
              }
            </div>

            <div class="col-span-2 flex flex-col gap-2 sm:col-span-1 sm:col-start-2 sm:self-end">
              @if (!slot.enabled) {
                <p hlmMuted class="text-xs">
                  Produkt-Gutscheine sind unter
                  <a
                    class="underline"
                    routerLink="/settings"
                    [queryParams]="{ tab: 'sell-settings' }"
                    >Verkauf</a
                  >
                  ausgeschaltet. Sobald du sie einschaltest, werden sie
                  {{ slot.design ? 'mit diesem Design' : 'mit der Standardvorlage' }} gedruckt.
                </p>
              }

              @if (slot.design?.status === 'draft') {
                <p class="text-destructive flex items-start gap-1.5 text-xs">
                  <ng-icon name="lucideTriangleAlert" class="mt-0.5 shrink-0" />
                  <span
                    >Diesem Design fehlt ein Pflichtelement (siehe „Pflichtangaben“ unten). Bis du
                    es im Editor ergänzt, werden PDFs mit der Standardvorlage gedruckt.</span
                  >
                </p>
              }

              <div class="flex flex-wrap gap-2">
                @if (slot.design; as design) {
                  <a
                    hlmBtn
                    size="sm"
                    [variant]="design.status === 'draft' ? 'default' : 'outline'"
                    [routerLink]="['/voucher-designs', design.public_id]">
                    <ng-icon name="lucidePencil" />
                    Bearbeiten
                  </a>
                  <button
                    hlmBtn
                    variant="outline"
                    size="sm"
                    type="button"
                    [disabled]="previewingId() !== null"
                    [attr.aria-label]="'Beispiel-PDF von ' + design.name + ' herunterladen'"
                    (click)="preview.emit(design)">
                    @if (previewingId() === design.public_id) {
                      <hlm-spinner />
                    } @else {
                      <ng-icon name="lucideDownload" />
                    }
                    Beispiel-PDF
                  </button>
                }
                <button
                  hlmBtn
                  variant="ghost"
                  size="sm"
                  type="button"
                  (click)="switchSlot.emit(slot.type)">
                  <ng-icon name="lucideRepeat" />
                  {{ slot.design ? 'Design wechseln' : 'Design wählen' }}
                </button>
              </div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</section>
